import React, { type ReactNode } from 'react';

import { useIntl } from 'react-intl-next';

import { fg } from '@atlaskit/platform-feature-flags';
import { SearchConfluenceSubtype, type SearchResultType as Type } from '@atlassian/search-client';

import type { Nullable } from '../../types';

import { messages } from './messages';

export type SearchResultTypeProps = {
	type: Type;
	defaultMessage?: ReactNode | null;
	subtype?: Nullable<SearchConfluenceSubtype>;
};

export const SearchResultType = ({
	type,
	defaultMessage = null,
	subtype,
}: SearchResultTypeProps) => {
	const { formatMessage } = useIntl();
	const message = messages[type];
	const isLiveDoc =
		subtype === SearchConfluenceSubtype.LIVE &&
		fg('confluence_live_pages_open_beta_trait_opted_in');

	if (!message) {
		return defaultMessage;
	}

	return <>{isLiveDoc ? formatMessage(messages.liveDoc) : formatMessage(message)}</>;
};

export const getSearchResultType = (type?: Type): React.JSX.Element | null => {
	if (!type || !messages[type]) {
		return null;
	}
	return <SearchResultType type={type} />;
};
